"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValuePath = void 0;
const isNumber_js_1 = require("../../../utils/validation/isNumber.js");
const isString_js_1 = require("../../../utils/validation/isString.js");
const charsToEscape = ['[', ']', '.'];
const formatValuePath = (valuePath) => {
    if (valuePath === undefined || valuePath.length === 0) {
        return undefined;
    }
    let path = '';
    let isRoot = true;
    for (const valuePathPart of valuePath) {
        if ((0, isString_js_1.isString)(valuePathPart)) {
            const shouldBeEscaped = charsToEscape.some(charToEscape => valuePathPart.includes(charToEscape));
            if (shouldBeEscaped) {
                path += `['${valuePathPart}']`;
            }
            else {
                path += `${isRoot ? '' : '.'}${valuePathPart}`;
            }
        }
        if ((0, isNumber_js_1.isNumber)(valuePathPart)) {
            path += `[${valuePathPart}]`;
        }
        isRoot = false;
    }
    return path;
};
exports.formatValuePath = formatValuePath;
